var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeture2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_200_175",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 75
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_200_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6957 38.3846V63M45.6087 32.2308V61.4615M4.52174 73C4.52174 66.6308 19.5109 61.4615 38 61.4615C56.4891 61.4615 71.4783 66.6308 71.4783 73M15.8435 57.5231L12.1304 53.7692M46.2326 48.5231L50.1739 44.5385M30.3913 35.3077C30.3913 42.9547 24.2596 49.1538 16.6957 49.1538C9.13175 49.1538 3 42.9547 3 35.3077C3 27.6607 9.13175 21.4615 16.6957 21.4615C24.2596 21.4615 30.3913 27.6607 30.3913 35.3077ZM73 44.5385C73 48.7868 69.5935 52.2308 65.3913 52.2308C61.1891 52.2308 57.7826 48.7868 57.7826 44.5385C57.7826 40.2901 61.1891 36.8462 65.3913 36.8462C69.5935 36.8462 73 40.2901 73 44.5385ZM45.6087 3C49.8109 3 53.2174 6.44396 53.2174 10.6923V32.2308C53.2174 36.4791 49.8109 39.9231 45.6087 39.9231C41.4065 39.9231 38 36.4791 38 32.2308V10.6923C38 6.44396 41.4065 3 45.6087 3Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeture2);
export default __webpack_public_path__ + "static/media/feture2.bf6d721ef86dfa20133950ff13aa58d0.svg";
export { ForwardRef as ReactComponent };